(function ($) {
  productContentMeetFamilyV1 = {
    formatter: $('.product-content-meet-family-v1')
  };

  Drupal.behaviors.productContentMeetFamilyV1 = {
    get: function (key) {
      return productContentMeetFamilyV1[key];
    },

    set: function (key, val) {
      productContentMeetFamilyV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);
        // setup rows of 4
        var items = thisFormatter.find('.inner');

        if (items.length >= 4) {
          items.css('width', '23%');
        }
        for (var i = 0; i < items.length; i += 4) {
          items.slice(i, i + 4).wrapAll('<div class="row"></div>');
        }
      });
    }
  };
})(jQuery);
